import React from 'react';
import PropTypes from 'prop-types';
import CustomLoader from 'components/CustomLoader';
import ModuleDisabled from 'components/ModuleDisabled';
import { useModuleDisabled } from 'utils/useModuleDisabled';

/** Renders `children` unless `module` is disabled for the workspace, in which case the disabled view is shown. */
const ModuleGuard = ({ module, children }) => {
    const { loading, disabled, isAdmin } = useModuleDisabled(module);

    if (loading) {
        return <CustomLoader active>{null}</CustomLoader>;
    }
    if (disabled) {
        return <ModuleDisabled module={module} isAdmin={isAdmin} />;
    }
    return children;
};

ModuleGuard.propTypes = {
    module: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default ModuleGuard;
